import { render } from "./CopyrightHover.vue?vue&type=template&id=c006af14&scoped=true&ts=true"
import script from "./CopyrightHover.vue?vue&type=script&lang=ts"
export * from "./CopyrightHover.vue?vue&type=script&lang=ts"

import "./CopyrightHover.vue?vue&type=style&index=0&id=c006af14&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c006af14"]])

export default __exports__